import api from '@/api/reports';

const actions = {
  FETCH_LESSON_HISTORY_REPORT: async ({ commit, dispatch, state }, learnerId) => {
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;

    const params = {
      limit: pageSize,
      user_id: learnerId,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'lessonHistoryReport.fetching', { root: true });

    try {
      const { count, results: report } = await api.fetchLessonHistoryReport(params);

      commit('SET_LESSON_HISTORY_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', 'lessonHistoryReport.fetching', { root: true });
    }
  },

  DOWNLOAD_LESSON_HISTORY_REPORT: async ({ state }, { formatType, learnerId }) => {
    const {
      dateRange: { start: startDate, end: endDate },
      ordering,
      filters,
    } = state;
    const search = filters.query;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    await api.fetchLessonHistoryReport({
      user_id: learnerId,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
      format: formatType,
      include: fields,
    });
  },

  FETCH_LESSON_SUMMARY: async ({ commit, dispatch, state }, learnerId) => {
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;

    const params = {
      limit: pageSize,
      user_id: learnerId,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'lessonSummary.fetching', { root: true });

    try {
      const { results: report } = await api.fetchLessonHistoryReport(params);

      if (report && report.length > 0) {
        const summary = report.slice(0, 5);
        commit('SET_LESSON_SUMMARY', summary);
      } else {
        commit('SET_LESSON_SUMMARY', report);
      }

      return report;
    } finally {
      dispatch('wait/end', 'lessonSummary.fetching', { root: true });
    }
  },

  FILTER_RESULTS: ({ commit, dispatch }, { query, learnerId }) => {
    commit('SET_SEARCH_QUERY', query);
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },

  CHANGE_PAGE_SIZE: ({ commit, dispatch }, { pageSize, learnerId }) => {
    commit('SET_PAGE_SIZE', pageSize);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage, learnerId }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },

  CHANGE_ORDERING: ({ commit, dispatch, state }, { ordering, learnerId }) => {
    if (ordering === state.ordering) {
      return;
    }

    commit('SET_ORDERING', ordering);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, { dateRange, learnerId }) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },

  RESET_LESSON_STATE: ({ commit, dispatch }, learnerId) => {
    commit('RESET_DATE_RANGE');
    commit('RESET_FILTERS');
    commit('RESET_PAGINATION');
    dispatch('FETCH_LESSON_HISTORY_REPORT', learnerId);
  },
};

export default actions;
